export const BUTTON_ID = 'notifications-button'
